enum ModalActionEnum {
    Type = "MODAL_STATE",
}

export default ModalActionEnum;